import { v4 as uuidv4 } from "uuid";
import { WROption } from "./option";

export class WRTile {
  id: string;
  title: string;
  text: string;
  extendedText: string;
  width: string;
  src: string;
  video: string;
  link: string;
  srcid: number;
  type: WRTileType;
  newTab: boolean;
  options: Array<WROption>;
  formidableId: string;
  imageType: WRTileImageType;
  backend_expanded: boolean = false;

  constructor(
    title: string = "",
    text: string = "",
    extendedText: string = "",
    width: string = "tile-full",
    src: string = "",
    video: string = "",
    link: string = "",
    srcid: number = 0,
    type: WRTileType = WRTileType.BASIC,
    newTab: boolean = false,
    options: Array<WROption>,
    formidableId: string,
    imageType: WRTileImageType = WRTileImageType.SINGLE_IMAGE,
    backend_expanded: boolean = false
  ) {
    this.id = uuidv4();
    this.title = title;
    this.text = text;
    this.extendedText = extendedText;
    this.width = width;
    this.src = src;
    this.video = video;
    this.link = link;
    this.srcid = srcid;
    this.type = type;
    this.newTab = newTab;
    this.options = options;
    this.formidableId = formidableId;
    this.imageType = imageType;
    this.backend_expanded = backend_expanded;
  }
}

export enum WRTileType {
  BASIC,
  POST,
  PAGE,
  MDL,
  WORKINGGROUP,
  POLL,
}

export enum WRTileTypeLabel {
  BASIC = "Basic",
  POST = "Beitrag",
  PAGE = "Seite",
  MDL = "Mdl",
  WORKINGGROUP = "Arbeitsgruppe",
  POLL = "Umfrage",
}

export enum WRTileImageType {
  SINGLE_IMAGE,
  GALERY,
  VIDEO,
}